"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBusinessTaxonomiesResponseToJSON = exports.GetBusinessTaxonomiesResponseFromJSONTyped = exports.GetBusinessTaxonomiesResponseFromJSON = void 0;
var _1 = require("./");
function GetBusinessTaxonomiesResponseFromJSON(json) {
    return GetBusinessTaxonomiesResponseFromJSONTyped(json, false);
}
exports.GetBusinessTaxonomiesResponseFromJSON = GetBusinessTaxonomiesResponseFromJSON;
function GetBusinessTaxonomiesResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'businessTaxonomies': (json['businessTaxonomies'].map(_1.BusinessTaxonomyFromJSON)),
    };
}
exports.GetBusinessTaxonomiesResponseFromJSONTyped = GetBusinessTaxonomiesResponseFromJSONTyped;
function GetBusinessTaxonomiesResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'businessTaxonomies': (value.businessTaxonomies.map(_1.BusinessTaxonomyToJSON)),
    };
}
exports.GetBusinessTaxonomiesResponseToJSON = GetBusinessTaxonomiesResponseToJSON;
